var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Minus","transform":"translate(0 0.6)"},React.createElement("line",{"id":"Linie_44","data-name":"Linie 44","y2":"12","transform":"translate(12 0) rotate(90)","fill":"none","stroke":"#1d1d1b","strokeWidth":"1.2"})));
}

MinusInline.defaultProps = {"width":"12","height":"1.2","viewBox":"0 0 12 1.2"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
